import {
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_APPROVAL_WORKFLOWS,
    GET_APPROVAL_WORKFLOW,
    CREATE_APPROVAL_WORKFLOW,
    EDIT_APPROVAL_WORKFLOW,
    DELETE_APPROVAL_WORKFLOW,
    GET_APPROVAL_WORKFLOW_STAGES,
    SAVE_APPROVAL_WORKFLOW_STAGES,
    GET_WORKFLOW_STAGE_TYPES,
    DELETE_WORKFLOW_STAGE_TYPE,
    CLEAR_APPROVAL_WORKFLOW
} from "../actions/types";

const initialState = {
    workflows: [],
    workflow: {},
    stages: [],
    stageTypes: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        // ensure no redux values linger between users ----
        case LOGIN_SUCCESS:
        case LOGOUT_SUCCESS:
        case LOGOUT_FAIL:
            return {
                ...initialState,
            }
        // ------------------------------------------------
        case GET_APPROVAL_WORKFLOWS:
            return {
                ...state,
                workflows: action.payload
            };
        case GET_APPROVAL_WORKFLOW:
        case CREATE_APPROVAL_WORKFLOW:
        case EDIT_APPROVAL_WORKFLOW:
            return {
                ...state,
                workflow: action.payload
            };
        case DELETE_APPROVAL_WORKFLOW:
            return {
                ...state,
                workflows: state.workflows.filter((workflow) => workflow.uuid !== action.payload)
            };
        case GET_APPROVAL_WORKFLOW_STAGES:
        case SAVE_APPROVAL_WORKFLOW_STAGES:
            return {
                ...state,
                stages: action.payload
            };
        case GET_WORKFLOW_STAGE_TYPES:
            return {
                ...state,
                stageTypes: action.payload
            };
        case DELETE_WORKFLOW_STAGE_TYPE:
            return {
                ...state,
                stageTypes: state.stageTypes.filter((stageType) => stageType.uuid !== action.payload)
            };
        case CLEAR_APPROVAL_WORKFLOW:
            return {
                ...state,
                workflow: {},
                stages: []
            };
        default:
            return state;
    }
}
